<template>
  <v-container fluid fill-height justify-center align-start align-lg-center id="scrolling-techniques-7" class="overflow-y-auto px-4" key="controllers">
    <transition name="router-anim" mode="out-in">

      <template v-if="state == 'controllers-exists'"> 
        <v-row class="max-w">
          <v-col cols="12" class="pb-0" v-for="(controller, i) in controllers" :key="i">
            <controllerCard :controller="controller" v-if="controller.controllerId"></controllerCard>
          </v-col>
          <v-col cols="12" class="px-2 pt-4">
            <div class="relative py-5 w-100 max-w">
              <v-fab-transition>
                <v-btn
                  absolute
                  fab
                  top
                  right
                  color="primary"
                  v-show="showAdd"
                  to="/controllers/new"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-fab-transition>
            </div>
          </v-col>

          <!--<v-col>
            <transition name="scale-transition">
              <div v-show="showFab" class="fab-container px-4">
                <v-btn 
                  to="/controllers/new"
                  x-large 
                  class="w-100" color="primary">{{ $t('dodaj-sterownik') }}</v-btn>
              </div>
            </transition>
          </v-col>-->
        </v-row>
        
      </template>
      <template v-else-if="state == 'no-controllers'">
        <v-row>
          <v-col cols="12" class="pb-0">
            <div class="display-1" v-html="$t('polacz-ze-ster')"></div>
          </v-col>
          <v-col cols="12">
            <v-carousel
              cycle
              interval="4000"
              height="110"
              hide-delimiter-background
              hide-delimiters
              :show-arrows="false"
            >
              <v-carousel-item
                v-for="(slide, i) in slides"
                :key="i"
              >
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center"
                >
                  <v-col class="subtitle-1 px-4 text-centerr">{{ $t(slide) }}</v-col>
                </v-row>
              </v-carousel-item>
            </v-carousel>
          </v-col>
          <v-col cols="12" class="text-center px-4">
            <v-btn 
                @click="controllersNew"
                x-large class="w-100" color="primary">{{ $t('dodaj-sterownik') }}</v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-row justify="center">
          <v-col cols="10" class="text-center px-8">
            <div class="title mb-3" v-html="$t('laczenie')"></div>
            <v-progress-linear
              indeterminate
              color="primary"
            ></v-progress-linear>
          </v-col>
        </v-row>
      </template>
    </transition>

  </v-container>
</template>

<script>
import ControllerCard from './../components/ControllerCard.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  data: () => ({
    slides: [
      'polacz-slajd-1',
      'polacz-slajd-2',
      'polacz-slajd-3'
    ],
    statee: 'loading',
    showFab: false,
    showAdd: false
  }),
  computed: {
    ...mapGetters([
      'controllers'
    ]),
    state() {
      //return 'no-controllers';
      if (this.controllers === null) {
        return 'loading'
      } else if (this.controllers.length > 0) {
        return 'controllers-exists'
      } else {
        return 'no-controllers'
      }
    },
    /*loading() {
      return this.$store.state.controllers.controllersLoading
    }*/
  },
  created () {
    this.syncControllers(false)
    .then(res => {
      if (res.error) {
        console.log(res);
        this.$router.push({ path: '/server-error' });
      }
      return res;
    })
    .then(res => {
      if (!res.error) {
        return this.$store.dispatch(`notifications/getNotifications`, { controllerId: null, forced: false })
      } else {
        return false;
      }
    });
  },
  mounted () {
    setTimeout(() => { this.showAdd = true; }, 200);
  },
  methods: {
    ...mapActions([
      'syncControllers'
    ]),
    controllersNew() {
      this.showFab = false;
      this.$router.push({ path: '/controllers/new' });
    },
    refresh() {
      this.syncControllers(true)
      .then(res => {
        console.log('Controllers.refresh');
    });
    }
  },
  components: {
    ControllerCard
  }
}
</script>